import { LoadingSpinner } from '@ecomm/checkout-icons'
import { useCartValue } from '@ecomm/data-cart'

import { ErrorMessage } from './ErrorMessage'
import { Summary } from './Summary'

export function OrderSummary() {
  const cart = useCartValue()
  const cartHasItems = cart._tag === 'with_items' || cart._tag === 'updating'

  return (
    <div data-component="order-summary" data-testid="order-summary">
      <div className="mt-6 text-lg lg:mt-8">
        <h2 className="flex w-full shrink-0 items-center whitespace-nowrap text-xl font-medium md:text-2xl">
          Order summary
        </h2>
      </div>
      <div className="my-2.5 md:my-5">
        {cartHasItems ? (
          <Summary />
        ) : cart._tag === 'error' ? (
          <ErrorMessage error={cart.val} />
        ) : (
          <div className="text-center">
            <h2>Loading your cart...</h2>
            <LoadingSpinner fillColor="#f79e00" size={48} />
          </div>
        )}
      </div>
    </div>
  )
}
